export const styles = () => ({
  form: {
    display: 'flex',
    justifyContent: 'space-evenly',
    marginTop: 4,
  },
});
